import scriptLoader from '@helper/script-loader';

const trackPid = async (pixelID) => {
  await scriptLoader('https://platform.twitter.com/oct.js');
  if (
    window.twttr &&
    window.twttr.conversion &&
    window.twttr.conversion.trackPid
  ) {
    window.twttr.conversion.trackPid(pixelID, {
      tw_sale_amount: 0,
      tw_order_quantity: 0,
    });
  }
};

export default {
  Wetransfer_site_visit() {
    trackPid('o24wa');
  },
  WeTransfer_Plus_Homepage_Visit() {
    trackPid('o24wd');
  },
  Wetransfer_Plus_Complete_Order_Conv() {
    trackPid('o24w8');
  },
  WeTransfer_Plus_Confirmation_Page_Conversion() {
    trackPid('o24w6');
  },
};
